export const TOOLBAR_MODES = {
    EDIT: 'edit',
    PREVIEW: 'preview',
    EDIT_PREVIEW: 'edit_preview',
}

export const ACTIVE_MODE_CLASS = 'bg-accent text-custom'